@import "@fontsource-variable/inter";
@import "tailwindcss";
@import "tw-animate-css";

@custom-variant dark (&:where(.dark, .dark *));

@theme {
  --font-sans: "Inter Variable", "Inter", ui-sans-serif, system-ui, sans-serif;
  --radius: 0.375rem;
  --color-background: #f6f7f9;
  --color-foreground: #18202b;
  --color-panel: #ffffff;
  --color-panel-foreground: #18202b;
  --color-muted: #eef1f4;
  --color-muted-foreground: #5e6875;
  --color-border: #d8dde4;
  --color-input: #ffffff;
  --color-ring: #176b87;
  --color-primary: #176b87;
  --color-primary-foreground: #ffffff;
  --color-secondary: #315c48;
  --color-secondary-foreground: #ffffff;
  --color-accent: #f1f5f9;
  --color-accent-foreground: #18202b;
  --color-destructive: #b42318;
  --color-destructive-foreground: #ffffff;
  --color-warning: #a15c00;
  --color-warning-foreground: #20130a;
  --color-success: #197653;
  --color-success-foreground: #ffffff;
}

.dark {
  --color-background: #111418;
  --color-foreground: #e5e7eb;
  --color-panel: #181d23;
  --color-panel-foreground: #f3f4f6;
  --color-muted: #232a32;
  --color-muted-foreground: #a7b0bc;
  --color-border: #303945;
  --color-input: #12161b;
  --color-ring: #44a1bd;
  --color-primary: #44a1bd;
  --color-primary-foreground: #071114;
  --color-secondary: #6bb790;
  --color-secondary-foreground: #07130d;
  --color-accent: #20262e;
  --color-accent-foreground: #f3f4f6;
  --color-destructive: #f97066;
  --color-destructive-foreground: #1f0d0b;
  --color-warning: #f2b84b;
  --color-warning-foreground: #20130a;
  --color-success: #58c79a;
  --color-success-foreground: #07130d;
}

* {
  border-color: var(--color-border);
}

html {
  min-width: 320px;
  background: var(--color-background);
}

body {
  margin: 0;
  min-height: 100vh;
  background: var(--color-background);
  color: var(--color-foreground);
  font-family: var(--font-sans);
  letter-spacing: 0;
}

button,
input,
select,
textarea {
  font: inherit;
}

#root {
  min-height: 100vh;
}

::selection {
  background: color-mix(in oklab, var(--color-primary) 22%, transparent);
}
